import { render, staticRenderFns } from "./travelSingle.vue?vue&type=template&id=dc686b2a&scoped=true"
import script from "./travelSingle.vue?vue&type=script&lang=js"
export * from "./travelSingle.vue?vue&type=script&lang=js"
import style0 from "./travelSingle.vue?vue&type=style&index=0&id=dc686b2a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc686b2a",
  null
  
)

export default component.exports